import {gql} from 'apollo-boost';

// The vdoSetTopics selections under `vdoSetUnits` here must match the one in
// GET_COURSEOUTLINE (src/queries/modules/courses/course-outline.js) -- see the
// comment in ./vdoSetUnit.js for why a narrower shape is a silent data loss on
// the VdoSet edit screen rather than a query error. GET_VDOSETS_BY_FILTER just
// below is the exception: its topics carry only the pointer fields the video
// COUNT on the list screen needs, and its result is never spliced into the
// edit screen's arrays.
export const GET_VDOSETS_BY_FILTER = gql`

  query getVdoSetsByFilter($vdoSetFilterInput: VdoSetFilterInput){
    getVdoSetsByFilter (
      vdoSetFilterInput:$vdoSetFilterInput
      # รับข้อมูลตามนี้จะใส่หรือไม่ใส่ก็ได้
      #  input VdoSetFilterInput {
      #    courseOutlineId: ID
      #    degreeId: ID
      #    subjectGroupId: ID
      #    subjectId: ID
      #    subjectCode: String
      #    teacherId: ID
      #    teacherCode: String
      #    code: String
      #  }
    ){
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher{
        id code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id
        vdoSetTopics{
          id vdoStreamPath
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
        }
      }

      label
    }
  }
`;

export const GET_VDOSETS = gql`
  query getVdoSets {
    getVdoSets {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher{
        id code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      teacherCode
      code
      description
      totalVdoLength

      label
    }
  }
`;

export const GET_VDOSET = gql`
  query getVdoSet($id : ID!){
    getVdoSet (
      id: $id
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher{
        id code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit {
          id seq
        }
        teacher {
          id code
          prefix{
            id nameLocal nameEng
          }
          firstNameLocal lastNameLocal
          firstNameEng lastNameEng picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
          bunnyStatusAt
        }
      }
    }
  }
`;

export const ADD_VDOSET = gql`
  mutation addVdoSet(
    $degreeId: ID!,
    $courseOutlineId: ID!,
    $subjectGroupId: ID!,
    $subjectId: ID!,
    $teacherId: ID!,
    $vdoSetInput: VdoSetInput!
  ) {
    addVdoSet(
      degreeId: $degreeId
      courseOutlineId: $courseOutlineId
      subjectGroupId: $subjectGroupId
      subjectId: $subjectId
      teacherId: $teacherId
      vdoSetInput: $vdoSetInput
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher{
        id code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit{ id nameLocal nameEng}
        teacher {
          id code
          prefix{
            id nameLocal nameEng
          }
          firstNameLocal lastNameLocal
          firstNameEng lastNameEng picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
          playbackUrl
          playbackStatus
          videoProvider bunnyVideoGuid bunnyStatus bunnyStatusAt
        }
      }
    }
  }
`;

export const UPDATE_VDOSET = gql`
  mutation updateVdoSet(
    $id: ID!,
    $code: String
    $description: String
  ) {
    updateVdoSet(
      id: $id
      code: $code
      description: $description
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher{
        id code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit{ id nameLocal nameEng}
        teacher {
          id code
          prefix{
            id nameLocal nameEng
          }
          firstNameLocal lastNameLocal
          firstNameEng lastNameEng picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
          playbackUrl
          playbackStatus
          videoProvider bunnyVideoGuid bunnyStatus bunnyStatusAt
        }
      }
    }
  }
`;

export const DELETE_VDOSET = gql`
  mutation deleteVdoSet($id: ID!) {
    deleteVdoSet(
      id: $id
    ) {
      id
      degree {
        id code nameLocal nameEng
      }
      courseOutline{
        id
      }
      subjectGroup{
        id code nameLocal nameEng
      }
      subject{
        id code nameLocal nameEng
      }
      subjectCode
      teacher{
        id code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      teacherCode
      code
      description
      totalVdoLength
      vdoSetUnits {
        id unitSeq code
        courseOutlineUnit {
          id seq
        }
        teacher {
          id code
          prefix{
            id nameLocal nameEng
          }
          firstNameLocal lastNameLocal
          firstNameEng lastNameEng picturePath
        }
        unitSeq
        code
        totalVdoLength
        status
        remark
        vdoSetTopics{
          id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
          playbackUrl
          playbackStatus
          videoProvider
          bunnyVideoGuid
          bunnyStatus
          bunnyStatusAt
        }
      }
    }
  }
`;

